import { IconUser, IconX } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import { NSButton } from 'bricks/NSButton/NSButton';
import './NSContactChip.scss';

interface INSContactChipProps {
    name: string;
    onRemove: () => void;
}

const NSContactChip: React.FC<INSContactChipProps> = ({ name, onRemove }) => (
    <div
        className="NSContactChip border border-primary bg-primary-lighten font-12 p-2 d-inline-flex align-items-center gap-1"
        aria-label={`Contact chip for ${name}`}
    >
        <NSIcon className="text-primary mr-1" icon={IconUser} size="sm" />
        <span className="text-primary mr-1">{name}</span>
        <NSButton
            className="text-primary p-0"
            callback={onRemove}
            aria-label={`Remove ${name}`}
            icon={IconX}
        />
    </div>
);

export default NSContactChip;
